import React from 'react';

const BillingFormModal = React.lazy(() => import('../components/FormModal'));
const billingModalRegistry = {
    core_billingId: BillingFormModal
};
export default billingModalRegistry;
